/**
 * Where a visitor may be sent back to after signing in. Only a short allow-list of in-app paths
 * is accepted, so a crafted `?returnUrl=` can never send anyone to another site or an arbitrary
 * route (an open redirect).
 */
const ALLOWED_PREFIXES: readonly string[] = ['/start/checkout', '/start/completed', '/start/course', '/profile', '/learn/'];

export function safeReturnUrl(raw: string | null | undefined): string | null {
  if (!raw || raw.length > 200) {
    return null;
  }
  // an in-app path only: one leading slash, no scheme, no backslash, no encoded tricks
  if (!raw.startsWith('/') || raw.startsWith('//') || raw.includes('\\') || raw.includes('://') || /%2f|%5c/i.test(raw)) {
    return null;
  }
  const path = raw.split(/[?#]/)[0];
  return ALLOWED_PREFIXES.some((prefix) => path === prefix || path.startsWith(prefix.endsWith('/') ? prefix : prefix + '/'))
    ? raw
    : null;
}
